// extracted by mini-css-extract-plugin
export var root = "_1CYv";
export var rootArrow = "ATYr";
export var rootArrows = "Sv-7";
export var rootCard = "WB8q";
export var rootCardFigure = "eiWV";
export var rootCardHeadText = "N+Lh";
export var rootCardImage = "aFX8";
export var rootCardLink = "_2ZJv";
export var rootCardPrice = "PA67";
export var rootCardRating = "NF72";
export var rootCardRatingValue = "+wVE";
export var rootCardStar = "EKsB";
export var rootCardStarFilled = "BLAy";
export var rootCardStarIcon = "vOWu";
export var rootCardStars = "QupP";
export var rootCarousel = "XM8Y";
export var rootCarouselContainer = "NRRw";
export var rootContainer = "XZ3h";
export var rootDot = "_1sA8";
export var rootDotActive = "-fPA";
export var rootDots = "aGrD";
export var rootEmptyLink = "zvb+";
export var rootEmptyState = "UuuR";
export var rootHeading = "lXVm";
export var rootPagination = "TUfD";
export var rootSlide = "FqUI";
export var rootTab = "V4Mr";
export var rootTabActive = "QjL5";
export var rootTabLink = "goJk";
export var rootTabs = "e71Y";